import styled, { css } from 'styled-components'

import { Activable } from './interface'

export const CollapseBox = styled.div``

export const PanelBox = styled.div`
  background-color: ${({ theme }) => theme.colors.brandPrimaryContrast};
  margin-bottom: ${({ theme }) => theme.space.lg};
  box-shadow: ${({ theme }) => theme.elevation.sm};
  position: relative;
  border-radius: 3px;
`

export const Header = styled.div<Activable>`
  border-radius: 3px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  display: flex;
  background-color: ${({ theme }) => theme.colors.brandPrimaryContrast};
  cursor: pointer;

  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) => theme.colors.brandPrimary};
      color: ${({ theme }) => theme.colors.text03};
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `}
`

export const Title = styled.div`
  flex: 1;
  min-width: 0;
  padding: ${({ theme }) => theme.space.md};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    align-items: center;
  }
`

export const HeaderButton = styled.div<Activable>`
  border-left: 1px solid ${({ theme }) => theme.palette.gray40};
  padding: ${({ theme }) => `${theme.space.xs} ${theme.space.xxs}`};
  background-color: ${({ theme }) => theme.colors.ui01};
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  display: flex;
  margin-left: auto;

  span {
    justify-content: center;
    align-self: center;
  }

  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) => theme.palette.blue80};
      padding: ${({ theme }) => `${theme.space.md} ${theme.space.sm}`};
      border-bottom-right-radius: 0;

      svg {
        font-size: ${({ theme }) => theme.fontSize.xs};
      }
    `}
`

export const StyledSection = styled.div<{ grayed?: boolean }>`
  ${({ grayed, theme }) =>
    grayed &&
    css`
      background: ${theme.palette.gray10};
    `}
`

export const ChildWrapper = styled.div<{ active?: boolean }>`
  display: ${({ active }) => (active ? 'block' : 'none')};
`
